export function getInsertSizeStats(features) {
  var filtered = features.map(function (f) {
    return Math.abs(f.tlen);
  });
  var sum = filtered.reduce(function (a, b) {
    return a + b;
  }, 0);
  var sum2 = filtered.map(function (a) {
    return a * a;
  }).reduce(function (a, b) {
    return a + b;
  }, 0);
  var total = filtered.length;
  var avg = sum / total;
  var sd = Math.sqrt((total * sum2 - sum * sum) / (total * total));
  var upper = avg + 4 * sd;
  var lower = avg - 3 * sd;
  return {
    upper: upper,
    lower: lower,
    avg: avg,
    sd: sd
  };
}
export function filterForPairs(features) {
  return features.filter(function (f) {
    return f.flags & 2 && !(f.flags & 256) && !(f.flags & 2048);
  });
}